import ErrorBoundary from "components/ErrorBoundary";
import ReactStrapTable from "components/reactStrapTable";
import React, { useEffect, useState } from "react";
import useAxios from "hooks/useAxios";
import { cellRendererCheck, currencyFormat, dateFormate } from 'utils/columns';


const ConfigurationsWholeSaler = ({
    searchTerms , 
     data ,
     thirdPartyAdminID ,
     SelectedChainPharmacyvalue,
     search

}) => {

      const API = useAxios();


    const [data1 , setData] = useState([]) ;
    const [columns, setColumns] = useState();


 useEffect(() => {
    if (thirdPartyAdminID != 0 && SelectedChainPharmacyvalue != "") {
      fetchtableData();
    }
  }, [thirdPartyAdminID, SelectedChainPharmacyvalue]);

    
    const fetchtableData = async () => {
        try {
            const {data} = await API.get(`GWConfig/Configuration/wholesaler/${thirdPartyAdminID}/${SelectedChainPharmacyvalue}`,{
                hasDefaultURL : true,
            }) ;
            if (data.length > 0) {
                setData(data) ;
            }
            else {
                setData({})
            }

        
        } catch (err) {
        }
    }
    let mainCol = [

        // {
        //     dataField: 'edit',
        //     text: 'Options',
        //     //   cellRenderer: (row) => cellRenderEdit(row),
        //     width: 100,
        //     show: true,
        //     disabled: true,
        //     hideColFilter: true,
        //     action: true,
        // },

        {
            dataField: 'pharmacyName',
            text: 'Pharmacy Name',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.pharmacyName),
        },
        {
            dataField: 'pharmacyNPI',
            text: 'Pharmacy NPI',
            sort: false,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: true,
             cellRenderer: (row) => cellRendererCheck(row.pharmacyNPI),
        },
        {
            dataField: 'wholeSalerName',
            text: 'Wholesaler Name',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.wholeSalerName),
        },

        {
            dataField: 'wholesalerAccountCode',
            text: 'Non-340B Account Code',
            sort: false,
            width: 170,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.wholesalerAccountCode),
        },
        {
            dataField: 'startDate',
            text: 'Start Date',
            sort: false,
            width: 140,
            show: true,
            inputType: 'date',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.startDate),
        },
        {
            dataField: 'endDate',
            text: 'End Date',
            sort: false,
            width: 140,
            show: true,
            inputType: 'date',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.endDate),
        }
    ]



    return (
        <div
            className='table-card scroll-table position-relative border-0 rounded pt-0'

        // fixed-height={tableData && tableData.length > 0 ? 'fixed-height' : 'default'}
        >      
            <ErrorBoundary>
                <ReactStrapTable
                    id="ConfigurationsWholeSaler"

                    columns={mainCol}
                    data={data1}
                />


            </ErrorBoundary>

        </div>
    )
};

export default ConfigurationsWholeSaler;